// @flow
/*eslint react/no-did-mount-set-state:0*/
import * as React from 'react';
import { noop } from 'lodash/fp';
import Spinner from '../spinner/spinner.component';
import { SpinnerContainer, PickerColonContainer } from './styles';
import { MINUTES_RANGE, HOURS_RANGE, SCHEDULE_RANGE } from './time-units.js';

const DEFAULT_FONT = 'Bariol, Arial, sans-serif';

type Props = {
    bgColor?: Object,
    color?: Object,
    'data-qa'?: string,
    handleChangeTime: noop,
    isAmPmDisplayFormat?: boolean,
    isScheduleFormat?: boolean,
    timeToDisplay: string
};

type State = {
    indexHour: number,
    indexMinute: number
};

/************************
 *   Helper functions   *
 ************************/

const getAmPmRange = () => {
    const hours = [];
    ['am', 'pm'].forEach(period => {
        ['12', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'].forEach(hour => {
            hours.push([{ text: hour, coef: 1 }, { text: period, coef: 0.3 }]);
        });
    });
    return hours;
};

const getHourAndMinuteIndexes = (time: string) => {
    const [hours, minutes] = time.split(':');
    return [parseInt(hours, 10), parseInt(minutes, 10)];
};

const getFormattedHours = (hours, minutes) => {
    return `${('0' + hours).substr(-2)}:${('0' + minutes).substr(-2)}`;
};

/*****************
 *   Component   *
 *****************/

class TimeSpinnerComponent extends React.Component<Props, State> {
    static defaultProps = {
        bgColor: { r: 255, g: 255, b: 255 },
        color: { r: 47, g: 68, b: 78 },
        handleChangeTime: () => undefined,
        isAmPmDisplayFormat: false,
        isScheduleFormat: false,
        timeToDisplay: '00:00'
    };

    constructor(props: Props) {
        super(props);

        const [indexHour, indexMinute] = getHourAndMinuteIndexes(props.timeToDisplay);
        this.state = {
            indexHour,
            indexMinute
        };
    }

    componentWillUpdate(nextProps: Props) {
        const { timeToDisplay } = nextProps;

        if (timeToDisplay !== this.props.timeToDisplay) {
            const [indexHour, indexMinute] = getHourAndMinuteIndexes(timeToDisplay);
            this.setState({ indexHour, indexMinute });
        }
    }

    handleChangeHourIndex = (newIndexHour: number) => {
        const { handleChangeTime } = this.props;
        const { indexMinute } = this.state;
        this.setState({ indexMinute, indexHour: newIndexHour });
        handleChangeTime(getFormattedHours(newIndexHour, indexMinute));
    };

    handleChangeMinuteIndex = (newIndexMinute: number) => {
        const { handleChangeTime } = this.props;
        const { indexHour } = this.state;
        this.setState({ indexMinute: newIndexMinute, indexHour });
        handleChangeTime(getFormattedHours(indexHour, newIndexMinute));
    };

    render() {
        const { bgColor, color, isAmPmDisplayFormat, isScheduleFormat, ...props } = this.props;
        const { indexHour, indexMinute } = this.state;

        return (
            <SpinnerContainer data-qa={props['data-qa']}>
                <div>
                    <Spinner
                        bgColor={bgColor}
                        color={color}
                        currentIndex={indexHour}
                        font={DEFAULT_FONT}
                        handleChangeIndex={this.handleChangeHourIndex}
                        isLoop
                        rangeValues={isAmPmDisplayFormat ? getAmPmRange() : HOURS_RANGE}
                        style={{ width: '100%', height: '100%' }}
                    />
                </div>
                <PickerColonContainer>:</PickerColonContainer>
                <div>
                    <Spinner
                        bgColor={bgColor}
                        color={color}
                        currentIndex={indexMinute}
                        font={DEFAULT_FONT}
                        handleChangeIndex={this.handleChangeMinuteIndex}
                        isLoop
                        rangeValues={isScheduleFormat ? SCHEDULE_RANGE : MINUTES_RANGE}
                        style={{ width: '100%', height: '100%' }}
                    />
                </div>
            </SpinnerContainer>
        );
    }
}

export default TimeSpinnerComponent;



// WEBPACK FOOTER //
// ./src/components/widgets/time-spinner/index.js